module.exports = __webpack_public_path__ + "img/DiHS_Icon_Wartebereich_59_2.010c16e8.svg";